import { UserInfo } from '../_models/UserInfo.model';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PortalService } from '../portale/_services/portal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from '../_services/config.service';
import { ModuleFunction } from '../_models/portal/ModuleFunction.model';

@Component({
  standalone: false,
	selector: 'app-kcs-modulo-ruoli',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './modulo-funzioni-ruoli.component.html',
})
export class ModuloFunzioniRuoliComponent implements OnInit {
	@Input() modNome!: string;

	funzioni: ModuleFunction[] = [];
	edit = 0;

	constructor(private route: ActivatedRoute, private router: Router, private portalService: PortalService, private configService: ConfigService) {}

	ngOnInit(): void {
		this.portalService.getFunzioniByUser(this.modNome).subscribe((funzioni) => {
			this.funzioni = funzioni;
			for (let i = 0; i < this.funzioni.length; i++) {
				if (this.funzioni[i].mdfu_nome?.toLowerCase() === 'permessi sezione') {
					this.edit = 1;
					break;
				}
			}
		});
	}
}
